import { render, staticRenderFns } from "./editTax.vue?vue&type=template&id=35732083"
import script from "./editTax.vue?vue&type=script&lang=js"
export * from "./editTax.vue?vue&type=script&lang=js"
import style0 from "./editTax.vue?vue&type=style&index=0&id=35732083&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports